import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const errorSelector = createSelector(selfSelector, (domainsReport) => domainsReport.error);

export default errorSelector;
